/* Livora IL: timer, menu, counters, ingredient toggle, bundle picker -> Shopify checkout permalink (keeps ad params), purchase toasts. */
(function () {
  var qs = location.search.replace(/^\?/, '');

  // keep tracking params on every internal order link
  function withParams(href) {
    if (!qs) return href;
    return href + (href.indexOf('?') > -1 ? '&' : '?') + qs;
  }
  document.querySelectorAll('[data-liv-order]').forEach(function (a) { a.href = withParams(a.getAttribute('href')); });

  // 15:00 countdown, restarts per visit like the source page
  var el = document.querySelector('[data-liv-timer]');
  if (el) {
    var key = 'livTimerEnd', end;
    try { end = +sessionStorage.getItem(key); } catch (e) {}
    if (!end || end < Date.now()) { end = Date.now() + 15 * 60 * 1000; try { sessionStorage.setItem(key, end); } catch (e) {} }
    var tick = function () {
      var s = Math.max(0, Math.round((end - Date.now()) / 1000));
      var m = Math.floor(s / 60), r = s % 60;
      el.textContent = '00:' + String(m).padStart(2, '0') + ':' + String(r).padStart(2, '0');
    };
    tick(); setInterval(tick, 1000);
  }

  var burger = document.querySelector('[data-liv-menu]'), panel = document.querySelector('[data-liv-menu-panel]');
  if (burger && panel) {
    burger.addEventListener('click', function () { panel.hidden = !panel.hidden; });
    panel.addEventListener('click', function (e) { if (e.target.tagName === 'A') panel.hidden = true; });
  }

  var more = document.querySelector('[data-liv-more]');
  if (more) more.addEventListener('click', function () {
    var s = more.closest('.liv-ings'); var open = s.classList.toggle('is-open');
    more.textContent = open ? more.dataset.less : more.dataset.more;
  });

  // count-ups, bars and chart animate when they scroll into view
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var t = e.target; io.unobserve(t);
      if (t.dataset.livCount) {
        var to = +t.dataset.livCount, t0 = performance.now();
        (function step(now) { var k = Math.min(1, (now - t0) / 1400); t.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); })(t0);
      } else t.classList.add('is-in');
    });
  }, { threshold: .35 }) : null;
  document.querySelectorAll('[data-liv-count],.liv-bar,.liv-chart').forEach(function (n) {
    if (io) io.observe(n); else { n.classList.add('is-in'); if (n.dataset.livCount) n.textContent = n.dataset.livCount; }
  });

  // bundle picker
  var packs = document.querySelectorAll('.liv-pack'), go = document.querySelector('[data-liv-checkout]');
  function setGo(id) { if (go) go.href = withParams('/cart/' + id + ':1'); }
  packs.forEach(function (p) {
    p.addEventListener('click', function () {
      packs.forEach(function (o) { o.classList.remove('is-on'); });
      p.classList.add('is-on'); p.querySelector('input').checked = true; setGo(p.dataset.variant);
    });
  });
  var on = document.querySelector('.liv-pack.is-on'); if (on) setGo(on.dataset.variant);

  // recent-purchase toasts (order page)
  var toast = document.querySelector('[data-liv-toast]');
  if (toast) {
    var names = ['נועה', 'מיכל', 'שירן', 'רונית', 'יעל', 'אורית', 'דנה', 'מורן', 'ליאת', 'הדס', 'סיגל', 'קרן'];
    var cities = ['תל אביב', 'חיפה', 'ראשון לציון', 'פתח תקווה', 'אשדוד', 'נתניה', 'באר שבע', 'חולון', 'רמת גן', 'רחובות', 'כפר סבא', 'מודיעין'];
    var what = ['3 קופסאות קפה סלים', '2 קופסאות קפה סלים', '3 קופסאות קפה סלים', 'קופסה אחת קפה סלים'];
    var pick = function (a) { return a[Math.floor(Math.random() * a.length)]; };
    var show = function () {
      toast.querySelector('[data-t-name]').textContent = pick(names);
      toast.querySelector('[data-t-city]').textContent = pick(cities);
      toast.querySelector('[data-t-what]').textContent = pick(what);
      toast.querySelector('[data-t-min]').textContent = 2 + Math.floor(Math.random() * 25);
      toast.hidden = false; setTimeout(function () { toast.hidden = true; }, 5000);
    };
    setTimeout(function () { show(); setInterval(show, 18000); }, 6000);
  }
})();
